var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.076 2H9.938C5.192 2 2 5.332 2 10.288V21.726C2 26.668 5.192 30 9.938 30H22.076C26.822 30 30 26.668 30 21.726V10.288C30 5.332 26.822 2 22.076 2Z",
    fill: "#F6F6F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6865 18.1741L17.5125 16.0011L19.6853 13.8281C20.1033 13.4113 20.1033 12.733 19.6853 12.3162C19.2674 11.8958 18.5916 11.897 18.1736 12.315L15.9995 14.488L13.8255 12.3126C13.4075 11.8946 12.7305 11.897 12.3125 12.3126C11.8958 12.7306 11.8958 13.4089 12.3125 13.8256L14.4878 16.0011L12.3174 18.1704C11.8995 18.5884 11.8995 19.2667 12.3174 19.6822C12.5264 19.8924 12.7989 19.9963 13.0727 19.9963C13.3476 19.9963 13.6202 19.8924 13.8291 19.6835L15.9995 17.5129L18.1748 19.6871C18.3838 19.8961 18.6563 20 18.9301 20C19.2038 20 19.4776 19.8949 19.6865 19.6871C20.1045 19.2691 20.1045 18.5921 19.6865 18.1741Z",
    fill: "#4A5361"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.e593d5750a245dfc736a5d387ee185cb.svg";
export { ForwardRef as ReactComponent };